export enum EConclusion {
  MortgageProfitable = 'mortgageProfitable',
  DepositProfitable = 'depositProfitable',
  MortgageNoSense = 'mortgageNoSense',
  NotMatter = 'notMatter',
  EnoughMoney = 'enoughMoney',
  NotEnoughMoney = 'notEnoughMoney',
  EmptyInput = 'emptyInput',
  DepositOnly = 'depositOnly',
  InadequateMortgagePayment = 'inadequateMortgagePayment',
}

export interface IConclusion {
  type: EConclusion;
  message: string;
}
